module.exports = __webpack_public_path__ + "img/cliente.c2e1ef30.png";